export const ERROR_MAP: { [key: string]: string } = {
  CODE_INVALID: 'Код неверный',
  TOO_MANY_REQUESTS: 'Много запросов',
  CODE_ALREADY_USED: 'Код был использован',
};

export const OTP_INPUT_STYLES = {
  width: '40px',
  height: '40px',
  marginRight: '10px',
  borderRadius: '4px',
  border: '1px solid rgba(206, 209, 215, 1)',
  backgroundColor: 'white',
  transition: 'all 0.4s',
  outline: 'none',
};

export const OTP_INPUT_FOCUSED_STYLES = {
  border: '1px solid rgba(4, 104, 255, 1)',
  boxShadow: '0 0 0 1px rgba(131, 180, 255, 1)',
};

export const OPT_INPUT_DISABLED_STYLES = {
  background: 'rgba(224,224,224,0.5)',
  cursor: 'not-allowed',
};
